import { useRoutes } from "react-router-dom";
import routes from "./router";
import mainRoutes from "./router-main";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import ThemeProvider from "./theme/ThemeProvider";
import { CssBaseline } from "@mui/material";
import PermissionProvider from "./permissions/permission.provider";
import AuthProvider, { useAuth } from "./auth/AuthProvider";

const App = () => {
  const content = useRoutes(routes.concat(mainRoutes));
  const profile = useAuth().getProfile()

  return (
    <ThemeProvider>
      <AuthProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <PermissionProvider permissions={profile ? profile.rights : []}>
            <>
              <CssBaseline />
              {content}
            </>
          </PermissionProvider>
        </LocalizationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
export default App;
